<div class="event-type-editor-page">
  <header class="editor-header">
    <button mat-icon-button type="button" (click)="cancel()" matTooltip="Volver al listado">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="header-copy">
      <h1>{{ pageTitle }}</h1>
      <p>{{ isEditMode ? 'Actualiza los datos del tipo de evento' : 'Crea un tipo disponible para el historial de comunidades' }}</p>
    </div>
  </header>

  <section *ngIf="isLoading" class="editor-panel">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Cargando tipo de evento...</p>
    </div>
  </section>

  <form *ngIf="!isLoading" [formGroup]="form" class="form-container">
    <section class="editor-panel">
      <h3>
        <mat-icon>event_note</mat-icon>
        Informacion general
      </h3>

      <div class="form-grid form-single-column">
        <mat-form-field class="full-width">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="ej: Inauguracion">
          <mat-error *ngIf="getControl('name')?.hasError('required')">El nombre es requerido</mat-error>
          <mat-error *ngIf="getControl('name')?.hasError('minlength')">Minimo 3 caracteres</mat-error>
          <mat-error *ngIf="getControl('name')?.hasError('maxlength')">Maximo 50 caracteres</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Descripcion</mat-label>
          <input matInput formControlName="description" placeholder="ej: Apertura de una comunidad">
          <mat-error *ngIf="getControl('description')?.hasError('maxlength')">Maximo 150 caracteres</mat-error>
        </mat-form-field>

      </div>
    </section>
  </form>

  <footer class="editor-footer">
    <span class="spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="isSaving">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button mat-flat-button color="primary" type="button" (click)="saveType()" [disabled]="!form.valid || isSaving">
      <mat-spinner *ngIf="isSaving" diameter="20" class="button-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      {{ isSaving ? 'Guardando...' : 'Guardar' }}
    </button>
  </footer>
</div>
